<template>
  <v-card
    flat
    tile
    :ripple="{ class: 'primary--text' }"
    class="d-flex justify-space-between align-center py-4 pl-4"
    @click="handleSwitch"
    @keydown.enter="handleSwitch"
  >
    <div class="d-flex align-center">
      <v-icon
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-flashlight
      </v-icon>
      <div class="text-body-1 text--text">
        {{ t('Онлайн-запись', options) }}
      </div>
    </div>
    <v-switch
      :value="filtersStore.unsavedFilters.isOnlineAppointment"
      :input-value="filtersStore.unsavedFilters.isOnlineAppointment"
      color="primary"
      class="pt-0 mt-0 pl-1"
      hide-details
      dense
      inset
      @input="emitChanges"
    />
  </v-card>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()

const emitChanges = (isEnabled: boolean) => {
  filtersStore.updateUnsavedFilters({
    isOnlineAppointment: isEnabled || undefined,
  })
  emit('input', {
    ...doctorFiltersState.value,
    isOnlineAppointment: isEnabled || undefined,
  })
}

const handleSwitch = () => {
  emitChanges(!filtersStore.unsavedFilters.isOnlineAppointment)
}
</script>
